/* src/app/components/blank-sheets-modal/blank-sheets-modal.component.scss */
.container {
  padding: 0 20px 20px 20px;
  max-width: 70%;
  margin: auto;
}
.container h1 {
  font-weight: 600;
  font-size: 32px;
  margin-top: 0;
}
.container span {
  font-weight: 400;
  font-size: 20px;
  text-align: center;
}
.container .sheetNumber {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: 500;
  border: none;
  width: 30px;
  z-index: 9;
  text-align: center;
  overflow: visible;
  outline: none !important;
}
.container .counterContainer {
  position: relative;
}
.container .counterContainer ion-button {
  height: 1.5em;
}
.container .counterContainer ion-button ion-icon {
  width: 12px;
}
.container .counterContainer ion-button::part(native) {
  padding: 8px;
}
.container ion-button {
  font-size: 20px;
  font-weight: 500;
  margin: 0;
}
.container ion-icon {
  width: 40px;
  height: 65px;
}
/*# sourceMappingURL=blank-sheets-modal.component-WSZWR2JX.css.map */
